import React from "react";
import { amendmentReasonText } from "./SourceEvidenceLink";
import AmendmentOriginalButton from "./AmendmentOriginalButton";

/** 원결정 사유와 변경고시 사유는 서로 다른 문서의 판단이므로 대체·혼합하지 않는다. */
export default function AmendmentReason({ amendment, hsk }) {
  const matched = amendment?.integrity_status === "matched" && amendment?.hs_after;
  const revoked = amendment?.integrity_status === "revoked";
  const reason = amendmentReasonText(amendment?.reason);
  return (
    <section aria-label="변경 후 결정사유" style={{ padding: 14, border: "1px solid var(--audit-border)", borderRadius: 8, background: "var(--audit-bg-subtle)", lineHeight: 1.7 }}>
      <div style={{ fontWeight: 750, marginBottom: 6 }}>
        {matched ? `변경 후 결정사유 · ${amendment.hs_after}` : revoked ? "결정 폐지 사유" : "변경고시 사유 · 사례 연결 확인 중"}
      </div>
      <div style={{ fontSize: 12, color: "var(--audit-text-muted)", marginBottom: 8 }}>
        {amendment?.gosi_no ? `제${amendment.gosi_no}호` : "품목분류 변경고시"}
        {amendment?.gosi_date ? ` · ${amendment.gosi_date}` : ""}
      </div>
      <div style={{ whiteSpace: "pre-line" }}>{reason || "저장된 변경고시에 결정사유가 없습니다. 고시 원문에서 확인해 주세요."}</div>
      {!matched && !revoked && <p style={{ color: "var(--audit-text-muted)" }}>아래 내용은 연결된 고시의 사유입니다. 이 사례에 적용되는 변경 후 세번은 아직 확인 중입니다.</p>}
      <div style={{ fontSize: 12, color: "var(--audit-text-muted)", marginTop: 8 }}>변경고시에 기재된 사유입니다. 변경 전 결정사유는 아래에 당시 기록으로 보존합니다.</div>
      <div style={{ marginTop: 8 }}><AmendmentOriginalButton amendment={amendment} hsk={hsk} label="변경사유 원문 확인" /></div>
    </section>
  );
}
